import styled from 'styled-components';
import { device } from '../lib/theme';

export const Title = styled.h1`
  color: ${({ white }: { white?: boolean }) => (white ? '#fff' : '#000')};
  font-family: 'CG-black', 'Arial Black', Helvetica, Arial, sans-serif;
  font-size: 40px;
  font-weight: 900;
  letter-spacing: 0px;
  line-height: 1.2;
  margin-bottom: 0;

  @media ${device.tablet} {
    font-size: 56px;
    line-height: 1.1;
  }
`;

export const SecondaryTitle = styled.h2`
  color: ${({
    white,
  }: {
    white?: boolean;
    center?: boolean;
    marginTop?: number | null;
    marginBottom?: number | null;
    width?: number;
  }) => (white ? '#fff' : '#2c2c2c')};
  font-family: 'CG-black', 'Arial Black', Helvetica, Arial, sans-serif;
  font-size: 32px;
  font-weight: 900;
  letter-spacing: 0px;
  line-height: 1.2;
  text-transform: capitalize;
  ${({ marginTop }) => (marginTop ? `margin-top: ${marginTop}px;` : null)}
  ${({ marginBottom }) =>
    marginBottom ? `margin-bottom: ${marginBottom}px;` : null}
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  ${({ center }) => (center ? 'text-align: center;' : null)}

  @media ${device.laptop} {
    font-size: 40px;
  }
`;

export const SectionTitle = styled.h3`
  letter-spacing: 0px;
  font-family: 'CG-bold', Helvetica, Arial, sans-serif;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.1;
  color: #2c2c2c;
`;

export const SubTitle = styled.h4`
  color: ${({ white }: { white?: boolean }) => (white ? '#fff' : '#000')};
  font-family: 'CG-regular', Helvetica, Arial, sans-serif;
  font-size: 22px;
  font-weight: 300;
  line-height: 1.1;
  letter-spacing: 0px;
  opacity: 1;
  text-align: left;

  @media ${device.tablet} {
    font-size: 28px;
    line-height: 1.2;
  }
`;

export const SecondarySectionTitle = styled.h5`
  letter-spacing: 0px;
  font-family: 'CG-regular', Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  color: ${({
    white,
  }: {
    white?: boolean;
    vspace?: number;
    marginTop?: number | null;
    marginBottom?: number | null;
    width?: number;
  }) => (white ? '#fff' : '#2c2c2c')};
  ${({ vspace = 0 }) =>
    vspace
      ? `
    margin-top: ${vspace}px;
    margin-bottom: ${vspace}px;
  `
      : null}
  ${({ marginTop }) =>
    marginTop !== null ? `margin-top: ${marginTop}px;` : null}
  ${({ marginBottom }) =>
    marginBottom !== null ? `margin-bottom: ${marginBottom}px;` : null}
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
`;

export const AccentText = styled.h6`
  color: #cd2127;
  letter-spacing: 0px;
  font-family: 'CG-bold', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
`;

export const Strong = styled.p`
  color: ${({ color }) => (color ? color : '#000000cc')};
  margin-bottom: ${({
    marginBottom = 16,
  }: {
    marginBottom?: number;
    uppercase?: boolean;
  }) => marginBottom}px;
  font-family: 'CG-bold', Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0;
  ${({ uppercase }) => (uppercase ? 'text-transform: uppercase' : null)}
`;

export const BulletList = styled.ul`
  padding-left: 26px;
  line-height: 24px;
  list-style: none;

  li {
    font-size: 16px;
    position: relative;
    margin-bottom: 16px;

    &:before {
      position: absolute;
      top: -5px;
      content: '\\2022';
      color: #cd2127;
      font-size: 42px;
      font-weight: bold;
      display: inline-block;
      width: 24px;
      margin-left: -28px;
    }
  }
`;

export const HorizontalLine = styled.div`
  height: 16px;
  background-image: linear-gradient(90deg, #cd2127, #063384);
`;

export const Disclaimer = styled.div`
  margin-top: 64px;
`;
